import React, {Component} from "react";
import {connect} from "react-redux";
import SVGIcon from "../svg/SVGIcon";
import {NAV, VIEWS} from "../../helpers/consts";
import {withRouter, Link} from 'react-router-dom';
import {setNavOpenAction} from "../../actions/SettingsAction";

import "./Nav.css";

class Nav extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hidden: false
    }
    this.onClickView = this.onClickView.bind(this);
    this.onClickToggle = this.onClickToggle.bind(this);
    this.setNavOpen = this.setNavOpen.bind(this);
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  onClickView(view,e){
    switch (view.type) {
      case 'view':
        e.preventDefault();
        this.props.history.push(view.link);
        break;
      case 'external':
        console.info('external link->', view.link)
        break;
      default:
        break;
    }
    this.setNavOpen(false);
  }

  onClickToggle(e) {
    e.preventDefault();
    const {nav} = this.props;
    this.setNavOpen(!nav.open);
  }

  setNavOpen(open){
    this.props.setNavOpenAction(open);
  }

  getButtonTypeClass(view){
    let className="fow-nav-item-full";
    if (!view.name){
      className = "fow-nav-item-icon";
    }
    if(!view.icon){
      className="fow-nav-item-label";
    }
    return className;
  }

  render() {
    const {nav, isMobile, hashParts} = this.props;
    const selected = hashParts
    const isNotMap = selected.type !== "page" ;
    const options = NAV.main;
    const linkHome = `/page/${VIEWS.HOME}`;

    return (
      <div id="fow-nav-placeholder">
        <div id="fow-nav" className={`fow-nav-${nav.fixed?'fixed':'static'}`}>
          <ul id="fow-view-nav" className={`${isNotMap ? '' : 'fow-is-home'} ${nav.open ?'fow-view-nav-open':''}`}>
            <li>
              <a href={linkHome} className={`fow-nav-item-brand fow-nav-item-label`} onClick={(e) => isMobile ? this.onClickToggle(e) : this.onClickView({type: 'view', link: linkHome}, e)}>
                <span className="fow-nav-brand fow-font-text fow-font-size-md">Future of Work in Europe</span>
                <span className="fow-collapse-btn"><SVGIcon width="30" name="eye" fill="transparent" /></span>
              </a>
            </li>
            {
              options.map((view)=>
                <li key={view.slug}>
                  <Link to={`?page=${view.link}`} className={`fow-nav-item ${selected.view === view.slug ? 'fow-selected' : ''} ${this.getButtonTypeClass(view)}`}>
                    {view.name &&
                      <span className="fow-nav-label fow-font-text fow-font-size-md">{view.name}</span>
                    }
                  </Link>
                </li>
              )
            }
            <li>
              <a href="https://www.mckinsey.com/featured-insights/future-of-work/the-future-of-work-in-europe" className={`fow-nav-item fow-nav-item-label`} target="_blank" rel="noopener noreferrer" >
                <span className="fow-nav-label fow-font-text fow-font-size-md">Read Report</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    nav: state.settings.nav,
    hashParts: state.settings.hashParts,
    hash: state.settings.hash,
    isMobile: state.settings.window.width < 768
  };
};
const mapDispatchToProps = dispatch => ({
  setNavOpenAction: open => dispatch(setNavOpenAction(open)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Nav));
